import React from 'react';
import { useRenderers } from '../../../../../renderProps';
import { ExchangeRefundPriceDetails } from '@entities/order';
const RefundPricesWithOverride = props => {
    const { RefundPrices: RefundPricesOverride = ExchangeRefundPriceDetails } = useRenderers();
    return React.createElement(RefundPricesOverride, Object.assign({}, props));
};
export default RefundPricesWithOverride;
